import { Routes } from '@angular/router';
import { invitadoGuard, sesionGuard } from '@auth';

/**
 * ⚠️ Toda ruta que aparezca en el CATALOGO de `NavegacionService` tiene que
 * existir aqui. El sintoma de un desajuste es un item de menu que no navega, sin
 * error en consola; lo verifica R4 de `pnpm run audit`.
 *
 * El modulo pendiente (Mis comisiones) tiene ruta REAL apuntando a
 * `EnDesarrolloPage`, con su rotulo en `data`. Sin ruta, R4 falla y el item del
 * menu se queda muerto.
 */
export const routes: Routes = [
  {
    path: 'login',
    canActivate: [invitadoGuard],
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    // ⚠️ EL MARCO ES UNA RUTA PADRE, Y ESO ARREGLA UN PARPADEO.
    //
    // Con el shell detras de un `@if (autenticado())` en `app.html`, su
    // visibilidad la decidia el estado de SESION y su contenido el ROUTER, que
    // cambian en momentos distintos: al entrar se veia el LOGIN dentro del
    // layout, y al salir el layout desaparecia antes que la pagina. Como ruta
    // padre, el router intercambia arbol viejo por nuevo de una sola vez y el
    // caso no puede darse. Ver el docblock de `ShellLayout`.
    //
    // ⚠️ LA GUARDA VIVE AQUI Y LAS HIJAS YA NO LA REPITEN. Una ruta nueva dentro
    // del marco queda protegida por construccion; antes habia que acordarse de
    // ponerle `canActivate` a cada una, y olvidarlo no da ningun error.
    path: '',
    canActivate: [sesionGuard],
    loadComponent: () => import('./shell-layout').then((m) => m.ShellLayout),
    children: [
      {
        path: 'inicio',
        loadComponent: () => import('./pages/inicio/inicio.page').then((m) => m.InicioPage),
      },
      {
        path: 'pedidos',
        loadComponent: () => import('./pages/pedidos/pedidos.page').then((m) => m.PedidosPage),
      },
      {
        // ⚠️ VA ANTES DE `pedidos/:id`, Y NO ES UNA PREFERENCIA DE ORDEN.
        //
        // El router de Angular resuelve por PRIMERA COINCIDENCIA: declarada
        // despues, `pedidos/:id` casaria con `/pedidos/nuevo` tomando "nuevo" como
        // el id, y el detalle pediria `GET /prepedidos/nuevo`. El backend responde
        // 400 por un Guid invalido y la pantalla diria "Pedido no encontrado" — el
        // alta seria inalcanzable, sin un solo error que apunte a la causa.
        path: 'pedidos/nuevo',
        loadComponent: () =>
          import('./pages/pedidos/pedido-nuevo.page').then((m) => m.PedidoNuevoPage),
      },
      {
        // El ID ENTRA COMO INPUT gracias a `withComponentInputBinding()` en
        // `app.config.ts`: el nombre del parametro tiene que coincidir con el del
        // `input()` del componente (`id`). Si no coincide, el input se queda sin
        // valor y no hay error que lo diga.
        //
        // Es el `Guid` del prepedido, no un folio: `api-broker` no tiene folio. La
        // URL lleva el uuid COMPLETO aunque la tabla muestre los 8 primeros
        // caracteres, porque aqui tiene que ser exacto.
        path: 'pedidos/:id',
        loadComponent: () =>
          import('./pages/pedidos/pedido-detalle.page').then((m) => m.PedidoDetallePage),
      },
      {
        path: 'facturas',
        loadComponent: () => import('./pages/facturas/facturas.page').then((m) => m.FacturasPage),
      },
      {
        // Era «Reportar pago» (en desarrollo). El pago se REPORTA en Mis facturas,
        // desde la seleccion; aqui se le da seguimiento.
        path: 'pagos',
        loadComponent: () => import('./pages/pagos/pagos.page').then((m) => m.PagosPage),
      },
      {
        path: 'comisiones',
        data: {
          titulo: 'Mis comisiones',
          subtitulo: 'Liquidaciones de tu cartera',
          mensaje:
            'Aquí verás la comisión devengada por cada pedido cobrado y el estado de su liquidación. ' +
            'La pantalla se habilitará en una próxima entrega.',
        },
        loadComponent: () =>
          import('./pages/en-desarrollo/en-desarrollo.page').then((m) => m.EnDesarrolloPage),
      },

      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
      // Una URL desconocida CON sesion cae en Inicio sin perder el marco. Va
      // como hija y no solo arriba: si ninguna hija casara, el padre dejaria de
      // casar y se saldria del area autenticada.
      { path: '**', redirectTo: 'inicio' },
    ],
  },
];
